import { SortathonPage } from '@features/portal-tools/sub-features/sortathon/components/SortathonPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/tools/sortathon')({
  component: RouteComponent,
  staticData: {
    crumb: {
        label: 'Sort-a-thon (ID Card Identifier)',
    }
  }
})

function RouteComponent() {
  return <SortathonPage />
}
